const video = document.getElementById("video");
const circlePlayButton = document.getElementById("circle-play-b");
const overlays = document.querySelector(".overlay"); // Fixed selector

function togglePlay() {
  if (video.paused || video.ended) {
    video.play();
  } else {
    video.pause();
  }
}
circlePlayButton.addEventListener("click", togglePlay);

video.addEventListener("playing", function () {
  circlePlayButton.style.opacity = 0;
  if (overlays) overlays.classList.remove("overlay-effect");
});

video.addEventListener("pause", function () {
  circlePlayButton.style.opacity = 1;
  if (overlays) overlays.classList.add("overlay-effect");
});

// $(document).ready(function () {
//   $("#buy-now-btn").click(function () {
//     let variantId = $(this).data("variant-id");
//     let quantity = $(this).data("quantity") || 1;

//     // Disable the button to prevent multiple clicks
//     $(this).prop("disabled", true).text("Adding...");

//     $.ajax({
//       type: "POST",
//       url: "/cart/add.js",
//       data: {
//         id: variantId,
//         quantity: quantity,
//       },
//       dataType: "json",
//       success: function () {
//         window.location.href = "/checkout"; // Redirect to checkout after adding
//       },
//       error: function (xhr, status, error) {
//         alert("Failed to add product to cart.");
//         // Re-enable the button in case of an error
//         $("#buy-now-btn").prop("disabled", false).text("Try Again");
//       },
//     });
//   });
// });
